import React from 'react';
import DataTable from 'react-data-table-component';
import { MenuComponent } from '../../assets/ts/components';

type Props = {
  data: any;
  columns: [];
  minHeight?: string;
};

const TableList: React.FC<Props> = ({ data, columns, minHeight = '0' }) => {
  return (
    <>
      <DataTable
        columns={columns}
        data={data}
        expandableRowsHideExpander
        onChangePage={() => {
          MenuComponent.reinitialization();
        }}
        pagination
        responsive
        customStyles={{
          table: {
            style: {
              minHeight: minHeight,
              backgroundColor: 'var(--tc-bg-surface)',
            },
          },
          tableWrapper: {
            style: {
              backgroundColor: 'var(--tc-bg-surface)',
            },
          },
          rows: {
            style: {
              borderBottom: '1px dashed var(--tc-border)',
              paddingTop: '5px',
              paddingBottom: '5px',
              backgroundColor: 'var(--tc-bg-surface)',
              color: 'var(--tc-text)',
            },
            highlightOnHoverStyle: {
              backgroundColor: 'var(--tc-bg-raised)',
              color: 'var(--tc-text)',
            },
          },
          headRow: {
            style: {
              borderBottom: '1px dashed var(--tc-border)',
              backgroundColor: 'var(--tc-bg-raised)',
            },
          },
          headCells: {
            style: {
              color: 'var(--tc-text-muted)',
            },
          },
          cells: {
            style: {
              color: 'var(--tc-text)',
            },
          },
          pagination: {
            style: {
              borderTopStyle: 'none',
              backgroundColor: 'var(--tc-bg-surface)',
              color: 'var(--tc-text)',
            },
            pageButtonsStyle: {
              color: 'var(--tc-text)',
              fill: 'var(--tc-text)',
            },
          },
          noData: {
            style: {
              backgroundColor: 'var(--tc-bg-surface)',
              color: 'var(--tc-text-muted)',
            },
          },
        }}
        paginationComponentOptions={{
          rowsPerPageText: 'Registros por página',
          rangeSeparatorText: 'de',
        }}
        noDataComponent={
          <>
            <div className="d-flex align-items-center">
              <div className="text-muted text-center fs-6 w-100 m-5">
                Sin registros
              </div>
            </div>
          </>
        }
        persistTableHead
      ></DataTable>
    </>
  );
};

export { TableList };
